/**
 * Pauta connector — internal types (Sprint 3.2).
 * Raw provider shapes stay here; never leak to UI / Search Engine.
 */

export const PAUTA_CONNECTOR_ID = 'pauta' as const
export const PAUTA_INTEGRATION_ID = 'int-pauta' as const
export const PAUTA_CONNECTOR_VERSION = '0.1.0-arch'

/** Normalized product after Parser (never HTML/DOM). */
export interface PautaProduct {
  codigo: string
  fabricante: string
  descricao: string
  preco: number | null
  estoque: number | null
  url: string
  prazo: string | number | null
  moeda: string
}

/** Simulated / future provider payload fragment. */
export interface PautaRawProductPayload {
  code?: string
  sku?: string
  brand?: string
  manufacturer?: string
  name?: string
  title?: string
  price?: number | string | null
  stock?: number | string | null
  qty?: number | string | null
  url?: string
  link?: string
  delivery?: string | number | null
  prazo?: string | number | null
  currency?: string
}

export interface PautaHealthReport {
  status: string
  lastConnectionAt: string | null
  version: string
  lastError: string | null
  sessionId: string | null
  integrationId: string
}
